(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();
  const isEn = () => (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const textNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const out = []; let node;
    while ((node = walker.nextNode())) out.push(node);
    return out;
  };
  const cleanEnglish = () => {
    if (!isEn()) return;
    const header = document.querySelector('#shopify-section-header');
    if (header) textNodes(header).forEach((node) => {
      node.nodeValue = node.nodeValue
        .replace(/\bBEGINNING\b/g, 'HOME')
        .replace(/\bBeginning\b/g, 'Home')
        .replace(/Motorbike Rental/g, 'Motorcycle Rental');
    });
    const main = document.getElementById('MainContent');
    if (main) textNodes(main).forEach((node) => {
      node.nodeValue = node.nodeValue
        .replace(/\bQUELAT\b/g, 'QUEULAT')
        .replace(/\bQuelat\b/g, 'Queulat')
        .replace(/Argentina\.Length/g, 'Argentina. Length');
    });
  };
  const movePremiumBlocks = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    document.querySelectorAll('.mat-premium-extra[data-mat-position="after-intro"]').forEach((block) => {
      const intro = main.querySelector('[id*="__intro"]');
      if (intro) intro.insertAdjacentElement('afterend', block);
      else main.prepend(block);
    });
    document.querySelectorAll('.mat-premium-extra[data-mat-position="after-prices"]').forEach((block) => {
      const prices = main.querySelector('[id*="__prices"], [id*="__precios"]');
      if (prices) prices.insertAdjacentElement('afterend', block);
      else main.append(block);
    });
    const tailor = document.querySelector('.mat-tailor-made[data-mat-position="replace-main-page"]');
    if (tailor) {
      const title = main.querySelector('.main-page-title');
      const original = title && title.closest('.shopify-section');
      if (original) original.hidden = true;
      main.prepend(tailor);
    }
  };
  const polishHomepage = () => {
    if (!document.body || !document.querySelector('main#MainContent')) return;
    const path = location.pathname.replace(/\/$/, '');
    const isHome = path === '' || path === '/' || path === '/en';
    if (!isHome) return;
    const main = document.getElementById('MainContent');
    textNodes(main).forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/1\.240/g, '2.270').replace(/1,240/g, '2,270');
    });
    [...main.querySelectorAll('a.button')].forEach((a) => {
      const href = a.getAttribute('href') || '';
      if (/carretera-austral|patagonia-chile-argentina|tierra-del-fuego/.test(href)) {
        a.textContent = isEn() ? 'VIEW DATES & ITINERARY' : 'VER ITINERARIO Y FECHAS';
      } else if (/arriendo-de-motos|motorcycle-rentals/.test(href)) {
        a.textContent = isEn() ? 'CHOOSE YOUR MOTORCYCLE' : 'ELEGIR MI MOTO';
      } else if (/viajes-a-la-medida|tailor-made/.test(href)) {
        a.textContent = isEn() ? 'PLAN A TAILOR-MADE TRIP' : 'DISEÑAR MI VIAJE';
      }
    });
    [...main.querySelectorAll('h2, h3')].forEach((h) => {
      const t = h.textContent.trim();
      if (/Tour Carretera Austral \(Noviembre 2025\)/i.test(t) || /Carretera Austral.*November 2025/i.test(t)) h.textContent = isEn() ? 'Carretera Austral · Highlights' : 'Highlights · Carretera Austral';
      if (/Tour Patagonia Chile\s*-\s*Argentina \(Enero 2024\)/i.test(t) || /Patagonia.*January 2024/i.test(t)) h.textContent = isEn() ? 'Patagonia Chile–Argentina · Highlights' : 'Highlights · Patagonia Chile–Argentina';
    });
    const video = main.querySelector('video[autoplay]');
    if (video) {
      video.preload = 'metadata';
      video.setAttribute('aria-label', isEn() ? 'Patagonia motorcycle adventure by Moto Austral Tours' : 'Aventura en moto por Patagonia con Moto Austral Tours');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    }
  };
  const improveHeadings = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const tour = document.querySelector('.mat-tour-guide');
    if (tour) {
      main.querySelectorAll('[id*="__day"] .image-with-text__heading, [id*="__dia_"] .image-with-text__heading').forEach((heading) => {
        if (heading.tagName !== 'H2') return;
        const h3 = document.createElement('h3');
        [...heading.attributes].forEach((attr) => h3.setAttribute(attr.name, attr.value));
        h3.innerHTML = heading.innerHTML;
        heading.replaceWith(h3);
      });
    }
    const path = location.pathname.toLowerCase();
    if (/\/pages\/contactanos\/?$/.test(path) || /\/pages\/contact\/?$/.test(path)) {
      const heading = main.querySelector('[id*="__intro"] .rich-text__heading, .main-page-title');
      if (heading && heading.tagName !== 'H1') {
        const h1 = document.createElement('h1');
        [...heading.attributes].forEach((attr) => h1.setAttribute(attr.name, attr.value));
        h1.innerHTML = heading.innerHTML;
        heading.replaceWith(h1);
      }
    }
  };
  const polishFooter = () => {
    const footer = document.querySelector('footer, .footer');
    if (!footer) return;
    textNodes(footer).forEach((node) => {
      const value = node.nodeValue.trim();
      if (value === 'Share contact information, store details, and brand content with your customers.') {
        node.nodeValue = isEn()
          ? ' Motorcycle tours and rentals in Patagonia, Chile. '
          : ' Tours y arriendo de motos en Patagonia, Chile. ';
      }
    });
  };
  ready(() => {
    movePremiumBlocks();
    cleanEnglish();
    polishHomepage();
    improveHeadings();
    polishFooter();
  });
})();
